import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    spacingContainer: {
      [breakpoints.down('md')]: {
        padding: '0px 8px 0px 9px',
      },
      [breakpoints.down(281)]: {
        padding: '0px 8px 85px 8px',
      },

      '& .grecaptcha-badge': {
        visibility: 'visible',
      },
    },
    title: {
      marginBottom: 8,

      '& b': {
        fontWeight: 'bold',
      },
    },
    subtitle: {
      marginBottom: 32,
      fontSize: 14,
    },
    link: {
      color: palette.secondary.main,
      display: 'flex',
      alignItems: 'center',
      fontSize: 12,
      paddingLeft: 20,
    },
    arrowIcon: {
      transform: 'rotate(180deg)',
      fontSize: 16,
    },
    forgotPassGrid: {
      [breakpoints.down(960)]: {
        marginTop: 20,
      },
      '& .MuiOutlinedInput-root': {
        height: 45,
        width: 340,
        borderColor: `${palette.darkGray} !important`,

        [breakpoints.down('md')]: {
          width: 290,
        },
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },

      '& .MuiFormControl-fullWidth': {
        width: 'auto',
      },
      '& .MuiFormLabel-root': {
        color: `${palette.darkGray} !important`,
        [breakpoints.down(960)]: {
          borderColor: `${palette.white} !important`,
          color: `${palette.white} !important`,
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        [breakpoints.down(960)]: {
          borderColor: `${palette.white} !important`,
          color: `${palette.white} !important`,
        },
      },
      '& .MuiInputBase-root': {
        [breakpoints.down(960)]: {
          color: `${palette.white} !important`,
        },
      },
    },
    loginButton: {
      backgroundColor: palette.navSuperAdmin,
      color: palette.white,
      height: 45,
      fontSize: 12,
      width: '85%',
      [breakpoints.down(350)]: {
        width: '100%',
      },
      '&:hover': {
        backgroundColor: palette.navSuperAdmin,
        color: palette.white,
      },
    },
    gridForgot: {
      justifyContent: 'center',
      [breakpoints.down(350)]: {
        justifyContent: 'unset',
      },
    },
    text: { fontSize: 35 },
  });
